<template>
  <div class="busRoute">
    <div class="busRoute__header1">
      <button class="btn-large primary" @click="addNew">Add New Route</button>
    </div>
    <div class="busRoute__header2">
      <div class="busRoute__header2__search">
        <i class="adx-ic_search"></i>
        <input v-model="searchBoxValue" type="text" placeholder="Search">
      </div>
      <div class="busRoute__header2__sort">
        <p>Sort by :</p>
        <div>
          <adx-dropdown-sort :value.sync="selectedSortValue" :type="true" :options="sortOptions"></adx-dropdown-sort>
        </div>
      </div>
    </div>
    <div class="busRoute__listing">
      <div  class="tableWrapper">
      <table>
        <thead>
          <tr>
            <td class="col1">Route</td>
            <td class="col2">Placement</td>
            <td class="col2">Owner</td>
            <td class="col3"></td>
          </tr>
        </thead>

        <tbody v-if="!isLoading">
          <tr v-for="(route, index) in routes" :key="index" class="content">
            <td class="col1">
              <div class="routeGroup">
                <div class="subhead route name">{{route.name}}</div>
                <div class="small-font detail">{{route.detail}}</div>
              </div>
            </td>
            <td v-if="route.placements.length === 0" class="col2"><span>-</span></td>
            <td v-else-if="route.placements.length > 0 && route.placements.length <= 2" class="col2">
              <div v-for="(placement, index) in route.placements" :key="index" class="subhead elipsis">
                {{placement}}
              </div>
            </td>
            <td v-else-if="route.placements.length > 2" class="col2">
              <div :class="[show[index] ? '': 'hidden']">
                <div v-for="(placement, index) in route.placements" :key="index" class="subhead elipsis">
                  {{placement}}
                </div>
              </div>
              <div v-if="!show[index]" class="showButton">
                <span class="small-font toggleShow" @click="showMore(index)">Show More</span>
                <i class="icon-chevrondown"></i>
              </div>
              <div v-else class="showButton">
                <span class="small-font toggleShow" @click="showMore(index)">Show Less</span>
                <i class="icon-chevronup"></i>
              </div>
            </td>
            <td class="col2"><span class="subhead owner">{{route.owner}}</span></td>
            <td class="col3">
              <menu-expansion :lists="route.delete? menuActions: menuActionsNot" @selected="selected($event, route)"/>
            </td>
          </tr>
        </tbody>
      </table>
      </div>

      <div class="emptyState">
        <adx-empty-selection v-if="isEmpty && !isLoading" :title="title"/>
      </div>
      <div v-if="isLoading" class="table__loadingWrapper">
        <slot name="loading" />
        <adx-loading/>
      </div>
      <div class="pagination" v-if="!isLoading && !isEmpty">
        <div class="total" >{{getDataRange}} of {{count}} Routes</div>
        <adx-pagination :selectedPage="selectedPage" :maxPage="maxPage" @change-page="selectPage"/>
      </div>
    </div>
    <adx-modal hideClose="true" v-if="isShowModal" title="Delete Route" type="small">
      <div slot="content" class="busRoute__modal">
        <div class="busRoute__modal__top">
          <span>Sure want to delete this route?</span>
        </div>
        <div class="busRoute__modal__bottom">
          <button class="btn-regular primary" @click="deleteRoute()">Yes<adx-loading-2 class="btn-loading" v-if="isLoadingMutation"/></button>
          <button class="btn-regular primary" @click="cancelDelete()">Cancel</button>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
  import DropdownSort from '@/components/Form/SelectDropdown';
import tooltip from '@/components/Tooltip';
import EmptySelection from '@/components/NotFound/Selection';
import Loading from '@/components/Loading/Primary';
import LoadingWhite from '@/components/Loading/Secondary-white';
import Pagination from '@/components/Pagination';
import MenuExpansion from '@/components/MenuExpansion';
import Modal from '@/components/Modal';

import * as validationLib from '@/lib/validation/'
import { mapGetters } from 'vuex'
import { parseErrorGql } from '@/lib/error'

const {
  helpers,
} = validationLib;

export default {
  name: 'adx-bus-route',
  components: {
    'adx-modal': Modal,
    'adx-dropdown-sort': DropdownSort,
    "tooltip": tooltip,
    'adx-empty-selection': EmptySelection,
    'adx-loading': Loading,
    'adx-loading-2': LoadingWhite,
    'adx-pagination': Pagination,
    'menu-expansion': MenuExpansion,
  },
  props: {

  },
  data() {
    return {
      title: "You dont have any Route here. lets create some !",
      isShowModal: false,
      selectedRouteId: null,
      show: [],
      selectedPage: 1,
      maxPage: 1,
      selectedSortValue: "last_added",
      searchBoxValue: null,
      isLoadingMain:false,
      isLoadingMutation: false,
      isEmpty: false,
      count: 0,
      countDuplicate: 0,
      countDelete: 0,
      sortOptions: [
        {
          label: "Last Added",
          value: "last_added",
        },
        {
          label: "First Added",
          value: "first_added",
        },
        {
          label: "Name",
          value: "name",
        }
      ],
      menuActionsList: [],
      menuActions: [
        {
          'id': 0,
          'name': ' Edit Route',
          'value': 'editroute',
        },
        {
          'id': 1,
          'name': ' Duplicate Route',
          'value': 'duplicateroute'
        },
        {
          'id': 2,
          'name': 'Delete Route',
          'value': 'deleteroute'
        }
      ],
      menuActionsNot: [
        {
          'id': 0,
          'name': ' Edit Route',
          'value': 'editroute',
        },
        {
          'id': 1,
          'name': ' Duplicate Route',
          'value': 'duplicateroute'
        }
      ],
      routes: []
    }
  },
  computed: {
    ...mapGetters({
      token: 'token'
    }),
    isLoading: function(){
      return this.isLoadingMain || this.isLoadingMutation || false
    },
    getDataRange: function(){
      let endPage = this.selectedPage*15;
      return this.count > 15? ((endPage < this.count)? endPage: endPage-15+(this.count%15)) : this.count
    },
  },
  apollo: {

  },
  watch: {
    searchBoxValue: helpers.debounce(function () {
      this.selectedPage = 1;
      this.count = 0;
      this.getRoutes()
    }, 500),
    selectedSortValue: function () {
      this.selectedPage = 1;
      this.count = 0;
      this.getRoutes()
    },
    selectedPage: function (){
      this.count = 0;
      this.getRoutes()
    }
  },
  beforeCreate() {

  },
  created() {
    localStorage.setItem('apollo-token', this.token);
    this.getRoutes();
    this.createShowArray()
  },
  beforeMount() {

  },
  mounted() {
    
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async getRoutes(){
      this.isLoadingMain = true;
      const res = await this.$apollo.query({
        query: require('@/graphql/bus/query/routesPage.gql'),
        loadingKey: 'loading',
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
        variables:{
          input: this.selectedPage.toString() || "1",
          sort: this.selectedSortValue.toString() || "last_added",
          search: this.searchBoxValue != null ? this.searchBoxValue.toString() : undefined,
          admin: "true"
        },
      });
      if(res.data){
        this.isEmpty = false;
        this.routes = [];

        const { routesPage } = res.data;
        if (res.errors){
          this.handleError(res.errors, 'route', 0)
        } else{
          const meta = routesPage.meta;
          const routes = routesPage.routes;
          routes.forEach(obj => {
            this.routes.push({
              id: obj.id,
              name: obj.title,
              detail: this.processedDetail(obj.routeDetails, obj.category),
              placements: this.processedPlacement(obj.generics),
              owner: obj.owner.email || "JohnDoeEmailnyaKepanjangan@gmail.com",
              delete: !obj.generics.length
            })

          });
          this.maxPage = meta.maxPage;
          this.count = meta.count;
          if (this.routes.length === 0) this.isEmpty = true;
          this.isLoadingMain = false
        }
      }

    },
    addNew() {
      this.$router.push({name: 'addnewroute'})
    },
    selected(index, item){
      if(index.value ===  'editroute'){
        this.$router.push({name: 'editroute',  params: {  id: item.id }})
      } else if(index.value ===  'duplicateroute'){
        this.duplicateRoute(item.id)
      } else if(index.value ===  'deleteroute'){
        this.confirmDelete(item.id)
      }
    },
    async duplicateRoute(id) {
      this.isLoadingMutation = true;
      const result = await this.$apollo.mutate({
        mutation: require('@/graphql/bus/mutation/routeDuplicate.gql'),
        loadingKey: 'loading',
        variables:{
            id: id.toString()
        },
        errorPolicy: 'all'
      });

      if (result.data) {
        if (result.errors){
          this.handleError(result.errors, 'duplicate', id)
        } else {
          this.count = 0;
          this.getRoutes();
          this.isLoadingMutation = false;
          this.$notify({
            group: 'saved',
            title: 'Success',
            text: `Data successfully duplicated!`,
            type: 'success'
          });
        }
      } else {
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: `Data failed to duplicate!`,
          type: 'danger'
        });
      }

    },
    async deleteRoute() {
      this.isLoadingMutation = true;
      const result = await this.$apollo.mutate({
        mutation: require('@/graphql/bus/mutation/routeDelete.gql'),
        variables:{
            id: this.selectedRouteId.toString()
        },
        errorPolicy: 'all',
      });
      if (result.data) {
        if (result.errors) {
          this.handleError(result.errors, 'delete', 0)
        } else {
          this.toggleModal();
          this.count = 0;
          this.getRoutes();
          this.isLoadingMutation = false;
          this.$notify({
            group: 'saved',
            title: 'Success',
            text: `Data successfully deleted!`,
            type: 'success'
          });
        }
      } else {
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: `Data failed to delete!`,
          type: 'danger'
        });
      }
    },
    async handleError(errors, param, id){
      const parsedError = parseErrorGql(errors);
      if (parsedError.hasError){
        if (parsedError.code === 403 || parsedError.code === 404 || parsedError.code === 204){
          let code = parsedError.code;
          if (parsedError.code === 204) code = 404;
          this.$router.push({ name: `${code}` })
        }else if (parsedError.code === 502){
          switch(param){
            case 'route':
              this.count++;
              if (this.count<3) {
                await this.getRoutes()
              } else{
                this.isLoadingMain = false;
                this.isEmpty=true;
                this.$notify({
                  group: 'saved',
                  title: 'Error',
                  text: `Something went wrong. Please refresh the page!`,
                  type: 'danger'
                });
              } 
              break;
            case 'duplicate':
              this.countDuplicate++;
              if (this.countDuplicate<3){
                await this.duplicateRoute(id)
              } else{
                this.isLoadingMutation = false;
                this.$notify({
                  group: 'saved',
                  title: 'Error',
                  text: `Data failed to duplicate!`,
                  type: 'danger'
                });
              }
              break;
            case 'delete':
              this.countDelete++
              if (this.countDelete<3){
                await this.deleteRoute()
              } else{
                this.isLoadingMutation = false
                this.toggleModal();
                this.$notify({
                  group: 'saved',
                  title: 'Error',
                  text: `Something went wrong! Data failed to delete!`,
                  type: 'danger'
                });
              }
              break;
          }
        }else {
          if (param === 'delete'){
           if (parsedError.code === 400) {
              this.toggleModal();
              this.isLoadingMutation = false
              this.$notify({
                  group: 'saved',
                  title: 'Error',
                  text: `Route has active campaign!`,
                  type: 'danger'
                });
            } else {
              this.$router.push({ name: `500` })
            }
          } else {
            this.$router.push({ name: `500` })
          }    
        }
      }
    },
    confirmDelete(id){
      this.selectedRouteId = id;
      this.toggleModal()
    },
    cancelDelete(){
      this.selectedRouteId = null;
      this.toggleModal()
    },
    toggleModal(){
      this.isShowModal = !this.isShowModal
    },
    showMore(index) {
      // assign array this way to make array change on DOM.
      this.$set(this.show, index, !this.show[index]);
    },
    selectPage(page) {
      this.selectedPage = page;
      this.count = 0;
      this.getRoutes()
    },
    processedDetail(array, category) {
      let processed = [];
      if (array){
        array.map(index => {
          processed.push(index.location)
        })
      }
      let processed_mid=[];
      if (processed.length > 3){
        let len = Math.round(processed.length/2);
        processed_mid.push(processed[len-1]);
        processed_mid.push(processed[len]);
        processed_mid.push(processed[len+1])
      } else {
        processed_mid = processed
      }
      let final_process = processed_mid.join(' - ');
      let cat = category? category.title : "";
      return '('+ cat+ ') Via ' + final_process
    },
    processedPlacement(bus) {
      let processed = [];
      if (bus){
        bus.map(index => {
          processed.push(index.title)
        })
      }
      return processed
    },
    createShowArray() {
      let i = 0;
      for (i = 0; i < this.routes.length; i++) {
        this.show.push(false)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>